import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: localStorage.getItem('token_barsara') || null
};

const loginSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('token_barsara', action.payload);
    },
    clearToken: (state) => {
      state.token = null;
      localStorage.removeItem('token_barsara');
    }
  }
});

export const { setToken, clearToken } = loginSlice.actions; 
export default loginSlice.reducer;